module.exports = __webpack_public_path__ + "static/media/kylas-sales-crm-removebg-preview.8adfa38b.png";